import Vue from 'vue'
import Vuex from 'vuex'
import Form from './utilities/Form'

window.Form = Form

Vue.use(Vuex)

const state = {
  token_log: null,
  token_header: null,
  nickname: null,
  role: 0,
  waitSkins: 0,
  waitPrivateSkins: 0,
  chat: {
    messages: [],
    users: [],
    userName: ''
  }
}

const mutations = {
  SET_TOKEN_LOG (state, token) {
    state.token_log = token
  },
  SET_TOKEN_HEADER (state, token) {
    state.token_header = token
  },
  SET_NAME (state, nickname) {
    state.nickname = nickname
  },
  SET_SKINS (state, number) {
    state.waitSkins = number
  },
  SET_PRIVATE_SKINS (state, number) {
    state.waitPrivateSkins = number
  },
  SET_ROLE (state, role) {
    state.role = role
  },
  INIT_MESSAGES (state, messages) {
    state.chat.messages = messages
  },
  INIT_USERS (state, users) {
    state.chat.users = users
  },
  GET_MESSAGE (state, message) {
    state.chat.messages.push(message)
  },
  REMOVE_TOKEN (state) {
    state.token_log = null
    state.token_header = null
  }
}

export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/store.js